/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Pdfsam_BestInputs */

const en_pc_alt_t_pdfsam_best = /** @type {(inputs: Pc_Alt_T_Pdfsam_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Splitting, merging, mixing, rotating and extracting pages`)
};

const zh_pc_alt_t_pdfsam_best = /** @type {(inputs: Pc_Alt_T_Pdfsam_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拆分、合并、交错合并、旋转和提取页面`)
};

/**
* | output |
* | --- |
* | "Splitting, merging, mixing, rotating and extracting pages" |
*
* @param {Pc_Alt_T_Pdfsam_BestInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_pdfsam_best = /** @type {((inputs?: Pc_Alt_T_Pdfsam_BestInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Pdfsam_BestInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_pdfsam_best(inputs)
	return zh_pc_alt_t_pdfsam_best(inputs)
});
export { pc_alt_t_pdfsam_best as "pc.alt.t.pdfsam.best" }